import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ResultadoService {

    private datosEdicion: any;
    constructor() {
        this.datosEdicion = new BehaviorSubject<any>(null);
    }

    // GETTERS
    getDataEdicion(){
        return this.datosEdicion.asObservable();
    }
    // SETTERS

    setDatosEdicion(valor){
        this.datosEdicion.next(valor);
    }
}
